import {
  I18nOptionsAutocompleteFieldWithController,
  SingleColumnFormLayout,
  TextFieldWithController,
} from '@procureai/ui-form-mui';
import { I18nOptionsAutocompleteProps } from '@procureai/ui-mui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { languages } from '~/common/constants';
import { CONTACT_ROLE_VARIANTS } from '~/common/types/ContactRoleVariant.ts';

import { SupplierContactData } from './SupplierContactEditForm.schema.ts';

const commonProps = {
  size: 'small' as const,
  fullWidth: true,
};

const enumNsMap: {
  [key in 'role' | 'language']: Pick<I18nOptionsAutocompleteProps, 'i18n' | 'options'>;
} = {
  role: {
    options: CONTACT_ROLE_VARIANTS,
    i18n: {
      keyPrefix: 'ContactRoleVariant',
    },
  },
  language: {
    options: languages,
    i18n: {
      keyPrefix: 'language',
    },
  },
};

export const SupplierContactEditForm = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'SupplierContactForm' });
  const { control } = useFormContext<SupplierContactData>();
  return (
    <SingleColumnFormLayout>
      <TextFieldWithController
        control={control}
        name="firstName"
        label={t('contact.firstName')}
        required
        {...commonProps}
      />
      <TextFieldWithController
        control={control}
        name="lastName"
        label={t('contact.lastName')}
        required
        {...commonProps}
      />
      <I18nOptionsAutocompleteFieldWithController
        control={control}
        name="role"
        label={t('contact.role')}
        required
        {...enumNsMap.role}
        {...commonProps}
      />
      <TextFieldWithController control={control} name="email" label={t('contact.email')} required {...commonProps} />
      <I18nOptionsAutocompleteFieldWithController
        control={control}
        name="language"
        label={t('contact.language')}
        required
        {...enumNsMap.language}
        {...commonProps}
      />
    </SingleColumnFormLayout>
  );
};
